import {
    DTOCardFormField,
    NestedField,
} from 'app/types/form.types'
import {
    InvoiceDesignation,
    InvoiceBulkOrIndividual,
    InvoiceStatus,
    InvoiceNormalAddon, CreditNoteReasons, LaneFeeTemplate,
} from 'app/enums/label.enums'
import {
    OutgoingInvoice,
    OutgoingInvoiceFields,
} from 'app/Apps/OrderManagement/Orders/orders.types'

const getInvoiceFields = ({
    getAllowedValues,
    isCreditNote,
    originalInvoiceAllowedValues,
    feeTemplate,
}: {
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
    isCreditNote: boolean,
    originalInvoiceAllowedValues: Record<string, any>,
    feeTemplate: LaneFeeTemplate,
}): DTOCardFormField<keyof (OutgoingInvoice & {feeTemplate: LaneFeeTemplate})>[] => {
    return [{
        title: 'Invoice',
        className: 'invoice',
        id: 'invoice',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'invoiceDesignation',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceDesignation),
                        disabled: true,
                        labelKey: 'INVOICE_DESIGNATION',
                    },
                    ...isCreditNote ? [{
                        name: 'creditNoteOriginalInvoice',
                        componentName: 'ObjectSelect',
                        allowedValues: originalInvoiceAllowedValues,
                        required: true,
                        noNone: true,
                        labelKey: 'ORIGINAL_INVOICE',
                    }] as NestedField<OutgoingInvoiceFields>[] : [],
                    ...isCreditNote ? [{
                        name: 'creditNoteReason',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(CreditNoteReasons),
                        useDropdown: true,
                        required: true,
                        noNone: true,
                        labelKey: 'CREDIT_NOTE_REASON',
                    }] as NestedField<OutgoingInvoiceFields>[] : [],
                    {
                        name: 'invoiceDate',
                        componentName: 'DateSelect',
                        labelKey: 'INVOICE_DATE',
                    },
                    {
                        name: 'invoiceNormalAddon',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceNormalAddon),
                        useDropdown: true,
                        labelKey: 'NORMAL_ADD_ON_INVOICE',
                    },
                ],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'invoiceBulkOrIndividual',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceBulkOrIndividual),
                        useDropdown: true,
                        labelKey: 'BULK_INDIVIDUAL_INVOICE',
                    },
                    {
                        name: 'invoiceTitle',
                        componentName: 'InputSingleline',
                        labelKey: 'TITLE',
                    },
                    {
                        name: 'laneInfo',
                        componentName: 'InputSingleline',
                        labelKey: 'LANE_INFORMATION',
                    },
                ],
            },
            {
                id: 'column3',
                fields: [
                    {
                        name: 'feeTemplate',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(LaneFeeTemplate),
                        value: feeTemplate,
                        disabled: true,
                        labelKey: 'FEE_TEMPLATE',
                    },
                    {
                        name: 'invoiceComment',
                        componentName: 'LongText',
                        labelKey: 'INVOICE_COMMENT',
                    },
                ],
            },
            {
                id: 'column4',
                fields: [
                    {
                        name: 'invoiceSentToSapOn',
                        componentName: 'DateSelect',
                        disabled: true,
                        labelKey: 'SENT_TO_SAP_ON',
                    },
                    {
                        name: 'changedBy',
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'CHANGED_BY',
                    },
                    {
                        name: 'invoiceStatus',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceStatus),
                        disabled: true,
                        labelKey: 'INVOICE_STATUS',
                    },
                ],
            },
        ],
    }]
}

export default getInvoiceFields
